import { Helmet } from "react-helmet";
import PageHero from "../components/reusables/hero/PageHero";
import ConsultationBody from "../components/consultation/ConsultationBody";

export default function Consultation() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/free-consultation"
        />
        <meta
          name="description"
          content="Claim a free business consultation with NTUNA.COM experts about your business. Get expert insights to understand and scale your business strategically."
        />
        
        <meta
          property="og:description"
          content="Claim a free business consultation with NTUNA.COM experts about your business. Get expert insights to understand and scale your business strategically."
        />
        <meta
          property="og:title"
          content="NTUNA.COM - Free Business Consultation | Uganda"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM - Free Business Consultation | Uganda"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM - Free Business Consultation | Uganda"
        />
        <meta
          name="twitter:description"
          content="Claim a free business consultation with NTUNA.COM experts about your business. Get expert insights to understand and scale your business strategically."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM - Free Business Consultation</title>
      </Helmet>
      <PageHero
        classes="dark-bg"
        titleClasses="title uppercase ntuna-deep-blue"
        title="Free Business Consultation"
      />
      <ConsultationBody />
    </>
  );
}
